import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.harvest_weighing_form', () => {
  void import('./internal/form').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.harvest_weighings_map', () => {
  void import('./internal/map').then(({ default: Component }) => Component());
});
